// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1Sda6{color:#fff;fill:#fff;height:40px;height:4rem;stroke:#fff;width:40px;width:4rem}._1qFS5{max-width:240px;max-width:24rem;overflow:hidden;overflow-wrap:break-word;text-overflow:ellipsis;white-space:nowrap}", ""]);
// Exports
exports.locals = {
	"avatarIcon": "_1Sda6",
	"userBox__email": "_1qFS5"
};
module.exports = exports;
